import { Info, Building2, LayoutList, ArrowUp } from 'lucide-react';

interface SelectContextFirstProps {
  className?: string;
}

export default function SelectContextFirst({ className = '' }: SelectContextFirstProps) {
  const openContextSelector = () => {
    window.dispatchEvent(new CustomEvent('open-context-selector'));
  };

  return (
    <div
      className={`rounded-xl border border-brand/30 bg-white p-4 sm:p-5 shadow-soft ${className}`}
      role="status"
      aria-live="polite"
    >
      <div className="flex gap-3">
        <div className="flex-shrink-0 w-9 h-9 rounded-full bg-brand/10 flex items-center justify-center">
          <Info className="w-5 h-5 text-brand" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-gray-900 text-sm sm:text-base">
            Select your context first
          </h3>
          <p className="text-xs sm:text-sm text-gray-600 mt-1">
            Use the selectors at the top of the screen to continue.
          </p>
          <ol className="mt-4 space-y-3">
            <li className="flex items-start gap-3">
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand text-white text-xs font-bold flex items-center justify-center">
                1
              </span>
              <div className="flex items-center gap-2">
                <Building2 className="w-4 h-4 text-brand flex-shrink-0" />
                <span className="text-sm font-medium text-gray-800">Select Mall</span>
              </div>
              <p className="sr-only">e.g. mall or organization</p>
            </li>
            <li className="flex items-start gap-3">
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand text-white text-xs font-bold flex items-center justify-center">
                2
              </span>
              <div className="flex items-center gap-2">
                <LayoutList className="w-4 h-4 text-brand flex-shrink-0" />
                <span className="text-sm font-medium text-gray-800">Select Program</span>
              </div>
              <p className="sr-only">e.g. offer or incentive program</p>
            </li>
          </ol>
          <p className="mt-4 flex items-center gap-2 text-xs text-brand font-medium">
            <ArrowUp className="w-4 h-4 flex-shrink-0" />
            Tap the dropdowns above to get started
          </p>
          <button
            type="button"
            onClick={openContextSelector}
            className="mt-4 w-full fc-btn-primary min-h-[44px]"
          >
            Choose Work Area
          </button>
        </div>
      </div>
    </div>
  );
}
